import React from 'react';
import classNames from 'classnames';
import { FormattedMessage, injectIntl } from '../../util/reactIntl';

import Button from '../Button/Button';
import IconClose from '../IconClose/IconClose';

import css from './Modal.module.css';

/**
 * Default close button for Modal component
 *
 * @component
 * @param {Object} props
 * @param {Function} props.onClick - Handler for close button click
 * @param {string} [props.closeButtonMessage] - Custom message for close button
 * @param {boolean} [props.lightCloseButton] - Use light color scheme for close button
 * @param {Object} props.intl - react-intl intl object
 * @returns {JSX.Element} Close button component
 */
const ModalCloseButton = (props) => {
  const { onClick, closeButtonMessage, lightCloseButton, intl } = props;

  const closeModalMessage = intl.formatMessage({ id: 'Modal.closeModal' });
  const closeButtonClasses = classNames(css.close, {
    [css.closeLight]: lightCloseButton,
  });

  return (
    <Button onClick={onClick} rootClassName={closeButtonClasses} title={closeModalMessage}>
      <span className={css.closeText}>
        {closeButtonMessage || <FormattedMessage id="Modal.close" />}
      </span>
      <IconClose rootClassName={css.closeIcon} />
    </Button>
  );
};

export default injectIntl(ModalCloseButton);
